import { ODSAlert, ODSButton, themeColors } from 'bc-ods';
import type { ReactElement, ReactNode } from 'react';
import { useIntl, defineMessages } from 'react-intl';

const messages = defineMessages({
  closeSuccessNotification: {
    id: 'SearchOrgsAndGroups.closeSuccessNotification',
    defaultMessage: 'Close success notification',
  },
});

type Props = {
  content: ReactNode;
  hide: () => void;
};

function RequestSuccessAlert({ content, hide }: Props): ReactElement {
  const intl = useIntl();
  return (
    <ODSAlert color="success" className="mb-2">
      <div className="d-inline-flex justify-content-between" style={{ width: '94%' }}>
        {content}
        <ODSButton
          title={intl.formatMessage(messages.closeSuccessNotification)}
          close
          toggle
          size="xs"
          iconColor={themeColors.success}
          onClick={hide}
        />
      </div>
    </ODSAlert>
  );
}

export default RequestSuccessAlert;
